let config = require('../config');
let HttpUtils = require('./http_utils');

const LOCAL_STORAGE_KEY = 'userPreferences';

export default class Preferences {

    constructor(options) {
        this.userId = options.userId;
        this.sessionToken = options.sessionToken;
    }

    get(callback) {
        getUserPreferences(this.userId, this.sessionToken, callback);
    };

    update(preferencesObj, callback) {
        updatePreferences(this.userId, this.sessionToken, preferencesObj, callback);
    };

    getFromLocalStorage() {
        return getPreferencesFromLocalStorage();
    };

    setInLocalStorage(preferences) {
        setPreferencesInLocalStorage(preferences);
    };

    makePreferencesObject(type, lang) {
        return makePreferencesObject(type, lang);
    };

    registerEvents(emitter) {
         registerEvents(emitter, this.userId, this.sessionToken);
    }
};

function getUserPreferences(userId, sessionToken, callback) {
    HttpUtils.get({
        uri: `${config.recEngineUrl}users/${userId}/preferences`,
        headers: {
            Authorization: `Bearer ${sessionToken}`
        }
    }, (success, body) => callback(success, JSON.parse(body)));
};

function setPreferencesInLocalStorage(preferences) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(preferences));
};

function getPreferencesFromLocalStorage() {
    let savedPreferences = localStorage.getItem(LOCAL_STORAGE_KEY);
    return JSON.parse(savedPreferences);
};

function makePreferencesObject(type, lang) {
    let savedPreferences = getPreferencesFromLocalStorage();
    let emptyObj = {
        playback: {}
    };

    if (savedPreferences) {
        if (typeof savedPreferences.playback !== 'undefined') {
            if (type === 'subtitles') {
                savedPreferences.playback.subtitles = lang;
            } else {
                savedPreferences.playback.audio = lang;
            }
        }
    } else {
        savedPreferences = emptyObj;
        if (type === 'subtitles') {
            savedPreferences.playback.subtitles = lang;
        } else {
            savedPreferences.playback.audio = lang;
        }
    }
    return savedPreferences;
};

function updatePreferences(userId, sessionToken, preferencesObj, callback) {
    HttpUtils.post({
        uri: `${config.recEngineUrl}users/${userId}/preferences`,
        headers: {
            Authorization: `Bearer ${sessionToken}`
        },
        body: preferencesObj
    }, (success, body) => callback(success, body));
};

function registerEvents(emitter, userId, sessionToken) {
     emitter.on('event', (type, eventObj) => {
        switch (type){
            case 'preferences-update' :
                const newPreferences = makePreferencesObject(eventObj.type, eventObj.targetLang);
                setPreferencesInLocalStorage(newPreferences);
                updatePreferences(userId, sessionToken, newPreferences, (success, response) => {
                    if (success) {
                        console.log('After the preferences have been set', response);
                    } else {
                        console.log('Failed to set preferences', response);
                    }
                });
                break;
            // case 'get-preferences-from-localstorage' :
            //      return getPreferencesFromLocalStorage();
        }
    });
}




// WEBPACK FOOTER //
// ./src/util/preferences_utils.js